;(function () {
  'use strict';

  // ユーザー側、Admin、Backyardそれぞれに対応するIDで要素を取得
  var $content = $('#content, #admin, #backyard');

  // ポップアップ用のDOMを返す
  function createModalDom(url) {
    var dom = '<div class="image-popup-modal js-image-popup-modal">' +
                '<span class="image-popup-modal-close"><i class="fal fa-times"></i></span>' +
                '<img class="image-popup-modal-content" src="' + url + '">' +
              '</div>'
    return dom
  }

  function removeWithFadeOut($dom) {
    $dom.fadeOut('fast').queue(function() {
      this.remove();
    });
  }

  // closest()をIEで使えるようにするポリフィル
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || 
                                Element.prototype.webkitMatchesSelector;
  }
  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;

      do {
        if (el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }

  // サムネイルをクリックしたときにモーダルを表示
  $.each($('.js-popup-image'), function() {
    var $img = $(this);
    
    $img.on('click', function(e){
      e.preventDefault();
      var modalDom = createModalDom($(this).context.href);
      $(modalDom).appendTo($content).hide().fadeIn('fast');
    });
  });

  // 画像以外の領域をクリックしたときにモーダルを消す（閉じるボタンを押したときの処理と兼用）
  $(document).on('click', function(e) {
    var $modal = $('.js-image-popup-modal');
    if(!e.target.closest('.image-popup-modal-content') && !e.target.closest('.popup-image-thumbnail') ) {
      removeWithFadeOut($modal);
    }
  });
  
  // ECSキーでモーダルを消す
  $(document).on('keydown', function(e) {
    var $modal = $('.js-image-popup-modal');
    if (e.key === 'Escape') {
      removeWithFadeOut($modal);
    }
  });

}.call(this));
